module.exports = __webpack_public_path__ + "img/logo_azul.04322bbb.png";